import type { ReactNode } from 'react';

import { ErrorBoundary } from '@highlight-cp/core-ui';
import { APP_ERROR_OUTCOME, reportClientError } from '@highlight-cp/metrics/client';

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary
      onError={(error, _errorInfo) => {
        reportClientError({
          outcome: APP_ERROR_OUTCOME.REACT_BOUNDARY,
          message: error.message,
          errorName: error.name,
        });
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
